import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type SendQueryResponseInThreadSubscriptionSubscriptionVariables = Types.Exact<{
   threadId: Types.Scalars['Int']
}>

export type SendQueryResponseInThreadSubscriptionSubscription = {
   __typename?: 'Subscription'
   sendQueryResponseInThreadSubscription?:
      | {
           __typename?: 'SendQueryResponseInThreadResult'
           threadId: number
           threadName: string
           threadSummary: string
           threadMessage: {
              __typename?: 'ThreadMessage'
              messageId: number
              threadId: number
              date: string
              timestamp: string
              createdAt: string
              content: string
              senderId: string
           }
        }
      | {
           __typename?: 'ThreadAccessDenied'
           threadId: number
           errorMessage?: string | null
        }
      | {
           __typename?: 'ThreadNotFound'
           threadId: number
           errorMessage?: string | null
        }
      | null
}

export const SendQueryResponseInThreadSubscriptionDocument = gql`
   subscription SendQueryResponseInThreadSubscription($threadId: Int!) {
      sendQueryResponseInThreadSubscription(threadId: $threadId) {
         ... on SendQueryResponseInThreadResult {
            threadId
            threadName
            threadSummary
            threadMessage {
               messageId
               threadId
               date
               timestamp
               createdAt
               content
               senderId
            }
         }
         ... on ThreadNotFound {
            threadId
            errorMessage: message
         }
         ... on ThreadAccessDenied {
            threadId
            errorMessage: message
         }
      }
   }
`
export type SendQueryResponseInThreadSubscriptionSubscriptionResult = Apollo.SubscriptionResult<
   SendQueryResponseInThreadSubscriptionSubscription
>
